import { render } from "./fichaindividual.vue?vue&type=template&id=029b9564&scoped=true"
import script from "./fichaindividual.vue?vue&type=script&lang=js"
export * from "./fichaindividual.vue?vue&type=script&lang=js"

import "./fichaindividual.vue?vue&type=style&index=0&id=029b9564&scoped=true&lang=css"
import "./fichaindividual.vue?vue&type=style&index=1&id=029b9564&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029b9564"]])

export default __exports__